import { useMemo } from 'react'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { useRestClient } from '@/contexts/QueryProvider'
import { DataTable } from '@/components/ui/DataTable'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { SkillForm } from '@/pages/Platform/Forms/SkillForm'
import { PlatformAgentSkillsFilters } from '@/pages/Platform/PlatformAgentSkillsTable/PlatformAgentSkillsFilters'
import { skillColumns } from '@/pages/Platform/PlatformAgentSkillsTable/platformAgentSkillsTableColumns'
import { AgentStudioBreadcrumbs } from '../AgentStudioBreadcrumbs'

export const AgentStudioSkillsPage = () => {
  const { getSkillApiGetSkills } = useRestClient()
  const { data: skills } = getSkillApiGetSkills.useSuspenseQuery(undefined)
  const sortedSkills = useMemo(() => [...skills].sort((a, b) => (a.name || '').localeCompare(b.name || '')), [skills])

  return (
    <>
      <AgentStudioBreadcrumbs title="Skills" />
      <TablePageContainer>
        <DataTable
          title="Manage Agent Skills"
          columns={skillColumns}
          data={sortedSkills}
          filters={(table) => <PlatformAgentSkillsFilters table={table} />}
          action={
            <SkillForm
              sheetTitle="New skill"
              sheetDescription="Create a reusable agent skill definition."
              sheetTrigger={
                <Button size="lg" variant="outline">
                  <IconPlusOutline className="mr-2" />
                  Add skill
                </Button>
              }
            />
          }
        />
      </TablePageContainer>
    </>
  )
}
